import { TimelineMax, Expo } from 'gsap';

export default function list(el) {
  const tl = new TimelineMax({
    paused: true,
  });

  tl
    .addLabel('start')
    .to(el, 1.2, {
      autoAlpha: 1,
      yPercent: 0,
      ease: Expo.easeInOut,
    }, 'start');

  return tl;
}
